import { addTraits } from 'src/api';

export const getMetrcReceipts = state =>
  addTraits(state.metrcReceipts.metrcReceipts);
